import React from 'react';
import styled from 'styled-components';
import ImageFadeIn from 'react-image-fade-in';
import numeral from 'numeral';
import { Subhead, Caption1, Title3 } from '../../../../components/Typography';
import ComboGroupCircles from './ComboGroupCircles';

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.theme.productPreviewAlignImage === 'left'
      ? '150px 1fr'
      : '1fr 150px'};
  grid-gap: 20px;
  align-items: center;

  padding: 10px;
  cursor: pointer;
  background: ${(props) => props.theme.comboInMenuBackgroundColor};
  border-radius: 12px;

  @media (max-width: 400px) {
    grid-template-columns: 91px 1fr !important;
    grid-gap: 16px !important;
  }

  @media (max-width: 500px) {
    grid-template-columns: 130px 1fr;
    grid-gap: 10px;
    :last-of-type {
      padding-bottom: 20px;
    }
  }

  @media (min-width: 501px) and (max-width: 768px) {
    grid-template-columns: 185px 1fr;
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    grid-template-columns: 120px 1fr;
  }

  &:hover {
    background-color: ${(props) =>
      props.theme.comboInMenuHoverStateBackgroundColor};
    transition: all 0.25s ease;
  }
`;

const InfoWrapper = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  align-items: center;
  padding: 16px 0;
  cursor: pointer;
  align-self: stretch;

  @media (max-width: 786px) {
    grid-template-columns: 1fr;
    grid-gap: 10px;
    padding: 4px 0;
  }
`;

const Image = styled(ImageFadeIn)`
  object-fit: cover;
  height: 150px;
  border-radius: ${(props) =>
    props.theme.productPreviewImageShape === 'circle' ? '50%' : '8px'};
  border: ${(props) => props.theme.productPreviewBorder};
  order: ${(props) =>
    props.theme.productPreviewAlignImage === 'left' ? 0 : 2};

  @media (max-width: 400px) {
    height: 91px;
  }

  @media (max-width: 500px) {
    height: 130px;
  }

  @media (min-width: 501px) and (max-width: 768px) {
    height: 185px;
  }

  @media (min-width: 769px) and (max-width: 1200px) {
    height: 120px;
  }
`;

const NameAndDescription = styled.div`
  display: grid;
  grid-gap: 10px;
  align-self: flex-start;
`;

const Name = styled(Title3)`
  text-transform: capitalize;
  font-weight: 600;
`;

const Description = styled(Caption1)`
  color: ${(props) => props.theme.darkGray};
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  line-height: 20px; /* fallback */
  -webkit-line-clamp: 4; /* number of lines to show */
  -webkit-box-orient: vertical;
  white-space: pre-wrap;
  max-height: 100px;
`;

const Footer = styled.div`
  margin-top: 15px;
  align-self: end;
`;

const Price = styled(Subhead)`
  justify-self: flex-end;
  color: ${(props) => props.theme.darkGray};
  display: ${(props) =>
    props.theme.productPreviewShowPrice ? 'inherit' : 'none'};
  float: right;
  margin-top: 10px;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.02px;
  text-align: right;
  color: #737a87;
`;

const ComboPreview = ({ combo, handleComboPreviewClick }) => {
  return (
    <Wrapper onClick={() => handleComboPreviewClick(combo.id, combo)}>
      <Image src={combo.image_url} />
      <InfoWrapper>
        <NameAndDescription>
          <Name>{combo.name.toLowerCase()}</Name>
          {combo.user_description && (
            <Description>{combo.user_description}</Description>
          )}
        </NameAndDescription>
        <Footer>
          <ComboGroupCircles combo={combo} />
          {combo.is_dollar_discount && (
            <Price>{numeral(combo.price.amount).format('$0.00')}</Price>
          )}
        </Footer>
      </InfoWrapper>
    </Wrapper>
  );
};

export default ComboPreview;
